import React, {Component, Fragment} from 'react';
import ApiService from "../ApiService";
import * as _ from "lodash";
import {CommandBarButton, MessageBarType, TextField} from "office-ui-fabric-react";
import {IMisConnectionDetailsResult} from "../../models/mis-connection-details/IMisConnectionDetailsResult";
import {IMisConnectionDetailsPutOperation} from "../../models/mis-connection-details/IMisConnectionDetailsPutOperation";
import {MessageBar} from "office-ui-fabric-react/lib-commonjs";

interface MisConnectionDetailsEditorProps
{
    tenantId: string;
    schoolCode: string;
    misName: string;
    
    details: IMisConnectionDetailsResult;
        
    apiService: ApiService;
    
    onDeleted(): void;
}

interface MisConnectionDetailsEditorState
{
    detailsPutOperation: IMisConnectionDetailsPutOperation;
    
    saveInProgress: boolean;
    saveMessage?: string;
    saveMessageBarType?: MessageBarType;
}

export default class MisConnectionDetailsEditor extends Component<MisConnectionDetailsEditorProps, MisConnectionDetailsEditorState> {
    static displayName = MisConnectionDetailsEditor.name;

    constructor(props: MisConnectionDetailsEditorProps) {
        super(props);

        this.state = {
            detailsPutOperation: {
                details: _.cloneDeep(this.props.details.detailsWithBlankSecrets),
                putSecrets: false
            },
            
            saveInProgress: false,
            saveMessage: undefined,
            saveMessageBarType: undefined
        };
    }

    async componentDidMount() {

    }

    async componentDidUpdate(prevProps: Readonly<MisConnectionDetailsEditorProps>, prevState: any): Promise<void> {

    }
    
    private save = async () => {
        
        this.setState({
            saveInProgress: true
        });
        
        try
        {
            const result = await this.props.apiService.putMisConnectionDetails(this.props.tenantId, this.props.schoolCode, this.props.misName, this.state.detailsPutOperation);
            
            this.setState({
                detailsPutOperation: {
                    details: result.detailsWithBlankSecrets,
                    putSecrets:false
                },
                saveInProgress: false,
                saveMessage: "Successfully saved mis connection details",
                saveMessageBarType: MessageBarType.success
            });
        }
        catch(e)
        {
            let message = e.message != undefined ? e.message : e;
            this.setState({
                saveInProgress: false,
                saveMessage: `Failed to save mis connection details : ${message}`,
                saveMessageBarType: MessageBarType.error
            })
        }
    }
    
    private delete = async () => {
        
        this.setState({
            saveInProgress: true
        });

        try
        {
            await this.props.apiService.deleteMisConnectionDetails(this.props.tenantId, this.props.schoolCode, this.props.misName);
            
            this.props.onDeleted();
        }
        catch(e)
        {
            this.setState({
                saveInProgress: false,
                saveMessage: `Failed to delete  mis connection details : ${e}`,
                saveMessageBarType: MessageBarType.error
            })
        }
    }

    private buildTextField(propertyName: string,propertyPath: string,isPassword: boolean,disabled: boolean)
    {
        const fullPath = `details.${propertyPath}.${propertyName}`;
        const value = _.get(this.state.detailsPutOperation, fullPath);

        return (
            <TextField key={propertyName} label={propertyName} value={disabled ? "" : value} type={isPassword ? "password" : "text"} disabled={disabled} onChange={
                (event, newValue) => {
                    const newPut = _.cloneDeep(this.state.detailsPutOperation);
                    _.set(newPut,fullPath,newValue);
                    
                    this.setState({
                        detailsPutOperation: newPut
                    });
                }
            }/>
        );
    }
    
    render() {
        
        const nonSecrets = Object.keys(this.props.details.detailsWithBlankSecrets.nonSecrets!).map(propertyName => this.buildTextField(propertyName,"nonSecrets",false,false));
        const secrets = Object.keys(this.props.details.detailsWithBlankSecrets.secrets!).map(propertyName => this.buildTextField(propertyName,"secrets",true,!this.state.detailsPutOperation.putSecrets));
        
        
        const secretsMessageBar = (
            <MessageBar
                messageBarType={MessageBarType.warning}
                isMultiline={false}>
                <span>All secrets must be provided when saving, blank values will overwrite any previously saved value.</span>
            </MessageBar>
        );
        
        const saveMessageBar = (
            <MessageBar
                messageBarType={this.state.saveMessageBarType}>
                <span>{this.state.saveMessage}</span>
            </MessageBar>
        );
        
        return (
            <Fragment>
                <div className="card">

                    <div className="card__header">
                        <span className={"card__title"}>{this.props.misName} at {this.props.tenantId} {this.props.schoolCode}</span>
                        
                        <CommandBarButton
                            iconProps={{ iconName: "delete"}}
                            text={"Delete"}
                            onClick={this.delete}
                        />
                        
                        <CommandBarButton
                            iconProps={{ iconName: this.state.detailsPutOperation.putSecrets ? "uneditable" : "edit"}}
                            text={this.state.detailsPutOperation.putSecrets ? "Don't edit secrets" : "Edit Secrets"}
                            onClick={() => {
                                
                                const newPut = _.cloneDeep(this.state.detailsPutOperation);
                                newPut.putSecrets = !newPut.putSecrets;
                                this.setState({
                                    detailsPutOperation: newPut
                                });
                            }}
                        />

                        <CommandBarButton
                            iconProps={{ iconName: "save"}}
                            text={"Save"}
                            disabled={this.state.saveInProgress}
                            onClick={this.save}
                        />
                    </div>

                    {!this.state.saveInProgress && this.state.saveMessage ? saveMessageBar : null}
                    {this.state.detailsPutOperation.putSecrets ? secretsMessageBar : null}

                    <div className={"card__content"}>
                        {nonSecrets}
                        <h4>Secrets</h4>
                        {secrets}
                    </div>
                </div>
            </Fragment>
        );
    }
}